import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n";
import { Toaster } from "sonner";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import Intro from "./components/site/Intro";
import Gallery from "./components/site/Gallery";
import Services from "./components/site/Services";
import Lifestyle from "./components/site/Lifestyle";
import Experiences from "./components/site/Experiences";
import MapSection from "./components/site/MapSection";
import Reviews from "./components/site/Reviews";
import Booking from "./components/site/Booking";
import Footer from "./components/site/Footer";

const Home = () => (
  <main className="bg-[#FBF9F5] text-charcoal overflow-x-hidden" data-testid="home-page">
    <Navbar />
    <Hero />
    <Intro />
    <Gallery />
    <Services />
    <Lifestyle />
    <Experiences />
    <MapSection />
    <Reviews />
    <Booking />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" toastOptions={{ style: { background: '#FBF9F5', color: '#1F1F1D', border: '1px solid #E2DFD8', borderRadius: 2 } }} />
      </I18nProvider>
    </div>
  );
}

export default App;
